// tslint:disable
import { ZendeskModel } from './zendesk.model';
import { Injectable } from '@angular/core';
import { UserProfileModel } from 'src/app/auth/models/user-profile.model';
import { get } from 'lodash';

function getWindow(): any {
  return window;
}

@Injectable({
  providedIn: 'root'
})
export class ZendeskService {
  private window;

  constructor(zendeskConfig?: ZendeskModel) {
    if (!zendeskConfig.accountUrl) {
      throw new Error('Missing accountUrl. Please set in app config via ZendeskWidgetProvider');
    }

    this.window = getWindow();

    let window = this.window
    // Following is essentially a copy paste of JS portion of the Zendesk embed code
    // with our settings subbed in. For more info, see:
    // https://support.zendesk.com/hc/en-us/articles/203908456-Using-Web-Widget-to-embed-customer-service-in-your-website

    
    window.zEmbed || function(e, t) {
      var n, o, d, i, s, a = [],
      r = document.createElement("iframe");
      window.zEmbed = function() {
        a.push(arguments)
      }, window.zE = window.zE || window.zEmbed,
      r.src = "javascript:false",
      r.title = "",
      r.style.cssText = "display: none",
      d = document.getElementsByTagName("script"),
      d = d[d.length - 1],
      d.parentNode.insertBefore(r, d),
      i = r.contentWindow,
      s = i.document;
      try {
        o = s
      } catch (e) {
        n = document.domain, r.src = 'javascript:var d=document.open();d.domain="' + n + '";void(0);',
        o = s
      }
      o.open()._l = function() {
        var e = this.createElement("script");
        n && (this.domain = n),
        e.id = "js-iframe-async",
        e.src = "https://assets.zendesk.com/embeddable_framework/main.js",
        this.t=+new Date,
        this.zendeskHost = zendeskConfig.accountUrl,
        this.zEQueue=a,
        this.body.appendChild(e)
      },
      o.write('<body onload="document._l();">'),
      o.close()
    }();

    this.window.zE(() => {
        zendeskConfig.beforePageLoad(this.window.zE)
      }
    )
  }

  public setLocale(locale) {
    this.window.zE(() => {
      this.window.zE.setLocale(locale)
    })
  }

  public identify(profile: UserProfileModel) {
    const user = {
      name: this.getUserFullName(profile),
      email: profile.email
    };

    this.window.zE(() => {
      this.window.zE.identify(user)
    })
  }

  public hide() {
    this.window.zE(() => {
      this.window.zE.hide()
    })
  }

  public show() {
    this.window.zE(() => {
      this.window.zE.show()
    })
  }

  public activate(options?) {
    this.window.zE(() => {
      this.window.zE.activate(options)
    })
  }

  public setHelpCenterSuggestions(options) {
    this.window.zE(() => {
      this.window.zE.setHelpCenterSuggestions(options)
    })
  }

  public setSettings(settings) {
    this.window.zESettings = settings
  }

  public updateFromProfile(profile?: UserProfileModel) {
    // generate custom user tags
    const userTags = [];
    if (profile != null) {
      const { premium_account, premium_account_type, developer_account, subscription } = profile;

      // permium user
      if (premium_account) {
        userTags.push(`premium_account_${premium_account_type}`);
        // subscription type
        if (subscription) {
          userTags.push(`subscription_${subscription.subscription_provider}`);
        }
      } else {
        userTags.push('free_account');
      }
      // developer
      if (developer_account) {
        userTags.push('developer_account');
      }
    }

    const isValid = get(profile, 'premium_account_valid', false);
    
    this.setSettings({
      // widget placement
      webWidget: {
        position: {
          horizontal: 'right',
          vertical: 'bottom'
        },
        offset: {
          horizontal: `0px`,
          vertical: `0px`
        },
        contactForm: {
          suppress: !(isValid), // Only allow paying users to contact support
          tags: userTags,
          fields: [
            { id: 'name', prefill: { '*': this.getUserFullName(profile) } }
          ]
        }
      }
    });
  }

  private getUserFullName(profile: UserProfileModel): string {
    if (profile) {
      const { first_name, last_name } = profile;
      return `${first_name} ${last_name}`;
    } else {
      return '';
    }
  }
}
